import { Box, SxProps, Theme } from '@mui/material'
import React from 'react'

interface ScanIconProps {
  width?: number
  height?: number
  sx?: SxProps<Theme>
}

export const ScanIcon = ({ width = 22, height = 16, sx }: ScanIconProps) => {
  return (
    <Box
      component='svg'
      width={width}
      height={height}
      viewBox='0 0 22 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      sx={{ color: 'text.disabled', flexShrink: 0, ...sx }}
    >
      <rect x='0' y='0' width='2' height='16' rx='1' fill='currentColor' />
      <rect x='4' y='0' width='1' height='16' rx='0.5' fill='currentColor' />
      <rect x='7' y='0' width='3' height='16' rx='0.5' fill='currentColor' />
      <rect x='12' y='0' width='1' height='16' rx='0.5' fill='currentColor' />
      <rect x='15' y='0' width='2' height='16' rx='0.5' fill='currentColor' />
      <rect x='19' y='0' width='1' height='16' rx='0.5' fill='currentColor' />
    </Box>
  )
}
